/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_BlockInputs */

const en_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Full Block`)
};

const fr_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Bloc plein`)
};

const de_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Vollständiger Block`)
};

const it_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Blocco completo`)
};

const ru_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Полный блок`)
};

const es_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Bloque completo`)
};

const zh_cn2_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（█）完整块`)
};

const ja_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（█）フルブロック`)
};

const hi_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) पूर्ण ब्लॉक`)
};

const pt_pt2_full_block = /** @type {(inputs: Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`( █ ) Bloco Completo`)
};

/**
* | output |
* | --- |
* | "( █ ) Full Block" |
*
* @param {Full_BlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const full_block = /** @type {((inputs?: Full_BlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_BlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_full_block(inputs)
	if (locale === "de") return de_full_block(inputs)
	if (locale === "it") return it_full_block(inputs)
	if (locale === "ru") return ru_full_block(inputs)
	if (locale === "es") return es_full_block(inputs)
	if (locale === "zh-CN") return zh_cn2_full_block(inputs)
	if (locale === "ja") return ja_full_block(inputs)
	if (locale === "hi") return hi_full_block(inputs)
	if (locale === "pt-PT") return pt_pt2_full_block(inputs)
	return en_full_block(inputs)
});